import { getCalApi } from '@calcom/embed-react'
import { useEffect } from 'react'
import { trackMeetingSchedule } from '../utils/analytics'

interface CalComModalProps {
  isOpen: boolean
  onClose: () => void
}

const CalComModal = ({ isOpen, onClose }: CalComModalProps) => {
  // Cal.com username ve event type
  const calUsername = 'thinklyze-bilgi-teknolojileri-naepds'
  const eventType = '30min' // Event type slug'ınızı buraya yazın
  
  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null
    
    if (isOpen) {
      // Track meeting modal open
      trackMeetingSchedule()
      
      const initCal = async () => {
        const cal = await getCalApi({ namespace: eventType })
        
        // Popup açılmasını engelle
        cal('ui', {
          hideEventTypeDetails: false,
          layout: 'month_view',
          theme: 'dark',
          styles: {
            branding: {
              brandColor: '#000000',
            },
          },
        })
        
        // Inline widget'ı göster - sadece bu gösterilecek
        cal('inline', {
          elementOrSelector: '#cal-inline',
          calLink: `${calUsername}/${eventType}`,
          config: {
            layout: 'month_view',
            theme: 'dark',
          },
        })
        
        // Cal.com'un floating button ve popup'ını gizle/kaldır
        const hidePopup = () => {
          // Floating button'ı kaldır
          const floatingButtons = document.querySelectorAll('[data-cal-namespace]:not(#cal-inline)')
          floatingButtons.forEach((btn) => btn.remove())
          
          // Popup overlay'leri gizle
          const popups = document.querySelectorAll('[class*="cal-com"], [id*="cal-popup"], [id*="cal-embed"]')
          popups.forEach((popup: Element) => {
            const el = popup as HTMLElement
            if (el.id !== 'cal-inline' && !el.closest('#cal-inline')) {
              el.style.display = 'none'
            }
          })
        }
        
        // Periyodik olarak kontrol et ve popup'ı gizle
        intervalId = setInterval(hidePopup, 200)
      }
      
      initCal()
    } else {
      // Modal kapandığında Cal widget'ını temizle
      const inlineElement = document.getElementById('cal-inline')
      if (inlineElement) {
        inlineElement.innerHTML = ''
      }
    }
    
    // Cleanup function
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [isOpen, eventType, calUsername])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div 
        className="w-full h-full max-w-6xl max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Cal.com Embed Container - Sadece embed görünsün */}
        <div className="w-full h-full overflow-auto">
          <div id="cal-inline" className="w-full h-full"></div>
        </div>
        
        {/* Cal.com popup'ını gizle */}
        <style>{`
          /* Cal.com floating button ve popup'ını gizle */
          [data-cal-namespace]:not(#cal-inline),
          [data-cal-namespace]:not(#cal-inline) *,
          .cal-com-popup,
          [class*="cal-floating-button"],
          [class*="cal-popup"],
          [id*="cal-popup"],
          [id*="cal-floating"],
          iframe[src*="cal.com"][src*="embed"]:not(#cal-inline iframe),
          body > div[style*="position: fixed"][style*="z-index"]:not([class*="cal-inline"]),
          div[role="dialog"]:not(#cal-inline div) {
            display: none !important;
            visibility: hidden !important;
          }
          
          /* Sadece inline widget görünsün */
          #cal-inline {
            display: block !important;
            visibility: visible !important;
          }
        `}</style>
      </div>
    </div>
  )
}

export default CalComModal














